import Vue from 'vue';

export default {
  bind(el, binding) {
    Vue.nextTick(() => {
      const dom = el.querySelector('.el-select-dropdown .el-select-dropdown__wrap');
      if (!dom) return;

      let timer = null;

      const scrollHandler = function() {
        const condition = this.scrollHeight - (Math.ceil(this.scrollTop) + 1) <= this.clientHeight * 3;
        if (condition) {
          if (timer) clearTimeout(timer);
          timer = setTimeout(() => {
            binding.value();
          }, 200);
        }
      };

      // 存储事件处理函数以便在unbind中移除
      dom._scrollHandler = scrollHandler;
      el._loadmoreDom = dom; // 保存引用
      dom.addEventListener('scroll', scrollHandler);
    });
  },
  unbind(el) {
    if (el._loadmoreDom && el._loadmoreDom._scrollHandler) {
      el._loadmoreDom.removeEventListener('scroll', el._loadmoreDom._scrollHandler);
      delete el._loadmoreDom._scrollHandler;
    }
  }
}
